import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {TreatmentWarning} from "it/primatoo/openapi/api/org/schemas/treatment/TreatmentWarning";

@Component({
  selector: 'pt-widget-app-summary-v0-warning',
  template: `
    <div class="alert alert-warning alert-widget" *ngIf="appListChangedActive">
      <div class="d-flex w-100">{{ 'MESSAGE.APP_LIST_CHANGED' | translate }}</div>
      <button type='submit'
              [disabled]="!editable"
              (click)="alignListChangedActive.emit()"
              class='btn btn-primary btn-sm ms-2'>{{ 'BUTTON.ALIGN' | translate }}
      </button>
<!--      <button type='submit'-->
<!--              [disabled]="!editable"-->
<!--              (click)="alignListChangedActive.emit(false)"-->
<!--              class='btn btn-outline-secondary btn-sm ms-2'>{{ 'BUTTON.IGNORE' | translate }}-->
<!--      </button>-->
    </div>

    <div class="alert alert-warning alert-widget" *ngIf="ridChangedActive">
      <div class="d-flex w-100">{{ 'MESSAGE.RID_CHANGED' | translate }}</div>
      <button type='submit'
              (click)="alignRidChangedActive.emit(true)"
              class='btn btn-primary btn-sm ms-2'>{{ 'BUTTON.ALIGN' | translate }}
      </button>
      <button type='submit'
              (click)="alignRidChangedActive.emit(false)"
              class='btn btn-outline-secondary btn-sm ms-2'>{{ 'BUTTON.IGNORE' | translate }}
      </button>
    </div>
  `,
  styles: [`
    .alert-widget {
      padding: 2px 10px;
      display: flex;
      align-items: center;
    }
  `]
})
export class WidgetAppSummaryV0WarningComponent implements OnChanges {
  @Input() editable: boolean;
  @Input() warnings: TreatmentWarning[]

  @Output() alignListChangedActive = new EventEmitter<boolean>();
  @Output() alignRidChangedActive = new EventEmitter<boolean>();


  public appListChangedActive = false;
  public ridChangedActive = false;

  ngOnChanges(changes: SimpleChanges): void {
    this.appListChangedActive = false;
    this.ridChangedActive = false;
    if (this.warnings) {
      if (this.warnings.find((w) => w === TreatmentWarning.APP_LIST_CHANGED)) {
        this.appListChangedActive = true;
      }
      if (this.warnings.find((w) => w === TreatmentWarning.RID_CHANGED)) {
        this.ridChangedActive = true;
      }
    }
  }

}

